import {
  Avgs,
  EXPORT_CRYO_BABY_LABELS,
  GET_AVG_DATA,
  GET_OPU_ENTRIES,
  GET_OPU_ENTRIES_PSE,
  GET_STATS_DATA,
  GET_STATS_DATA_PSE,
  OpuEntries,
  OpuStats,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

interface StatsDataResponse {
  statsData: OpuStats;
}
interface StatsDataPSEResponse {
  statsDataPSE: OpuStats;
}
interface OpuEntriesResponse {
  entryData: OpuEntries[];
}
interface OpuEntriesResponsePSE {
  entryDataPSE: OpuEntries[];
}

interface AvgDataResponse {
  avgData: Avgs[];
}

export const aspirationsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getStatsData: build.query({
      query: ({ aspirationDate, siteId, location }) => ({
        document: GET_STATS_DATA,
        variables: { aspirationDate, siteId, location },
      }),
      transformResponse: (response: StatsDataResponse) => response.statsData,
      providesTags: ['StatsData'],
    }),
    getStatsDataPSE: build.query({
      query: ({ aspirationDate, siteId, location }) => ({
        document: GET_STATS_DATA_PSE,
        variables: { aspirationDate, siteId, location },
      }),
      transformResponse: (response: StatsDataPSEResponse) =>
        response.statsDataPSE,
      providesTags: ['StatsData'],
    }),
    getAvgData: build.query({
      query: ({ aspirationDate, siteId }) => ({
        document: GET_AVG_DATA,
        variables: { aspirationDate, siteId },
      }),
      transformResponse: (response: AvgDataResponse) => response.avgData,
      providesTags: ['AvgData'],
    }),
    getOpuEntries: build.query({
      query: ({ aspirationDate, siteId, techId }) => ({
        document: GET_OPU_ENTRIES,
        variables: { aspirationDate, siteId, techId },
      }),
      transformResponse: (response: OpuEntriesResponse) => response.entryData,
      providesTags: ['OpuEntries'],
    }),
    getOpuEntriesPSE: build.query({
      query: ({ aspirationDate, siteId, pseId }) => ({
        document: GET_OPU_ENTRIES_PSE,
        variables: { aspirationDate, siteId, pseId },
      }),
      transformResponse: (response: OpuEntriesResponsePSE) =>
        response.entryDataPSE,
      providesTags: ['OpuEntries'],
    }),
    ExportCryoBabyLabels: build.mutation({
      query: (variables) => ({
        document: EXPORT_CRYO_BABY_LABELS,
        variables,
      }),
    }),
  }),
});

export const {
  useGetAvgDataQuery,
  useGetOpuEntriesQuery,
  useGetStatsDataQuery,
  useLazyGetAvgDataQuery,
  useLazyGetOpuEntriesQuery,
  useLazyGetStatsDataQuery,
  useGetOpuEntriesPSEQuery,
  useGetStatsDataPSEQuery,
  useExportCryoBabyLabelsMutation,
} = aspirationsApi;
